import { useEffect } from 'react';

import { useTokenContext } from '../../../context/TokenProvider/TokenProvider';
import { getAccessTokenInfo } from '../../../helpers/token/getAccessTokenInfo';
import { isDynatraceEnabled } from '../constants';
import { dynatraceIntegration } from '../dynatraceIntegration';
import { getUserIdentifierFromTokenInfo } from '../helpers/getUserIdentifierFromTokenInfo';

export const useIdentifyUserInDynatrace = () => {
	const { accessToken } = useTokenContext();

	useEffect(() => {
		const isDynatraceDisabledOrLoggedOut = !isDynatraceEnabled || !accessToken;

		if (isDynatraceDisabledOrLoggedOut) return undefined;

		const tokenInfo = getAccessTokenInfo(accessToken);

		if (!tokenInfo) return undefined;

		const maybeUserIdentifier = getUserIdentifierFromTokenInfo(tokenInfo);

		if (maybeUserIdentifier) {
			dynatraceIntegration.identifyUser(maybeUserIdentifier);
		}
	}, [accessToken]);
};
